import styled from 'styled-components';

export const CustomOption = styled.div`
  color: #161a30;
  cursor: pointer;
  background-color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

interface ICircle {
  color: string;
}

export const Circle = styled.div<ICircle>`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-right: 8px;
  background: ${({ color }) => color};
`;
